var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldText } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import cn from 'classnames';
import * as React from 'react';
import { durationConverter, isPositiveFiniteNumber } from 'utils/duration';
import styles from './index.module.scss';
export class DurationInput extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.maxInputLengthForMinutes = 2;
        this.maxInputLengthForHours = 4;
    }
    getCurrentValues(seconds) {
        if (seconds === undefined)
            return null;
        return durationConverter.seconds.toHoursAndMinutes(seconds);
    }
    handleChange(value) {
        const durationInSeconds = durationConverter.hours.toSeconds(value.hours) +
            durationConverter.minutes.toSeconds(value.minutes);
        this.props.input.onChange(durationInSeconds);
    }
    handleHoursInput(e) {
        var _a, _b;
        if (!e)
            return;
        const stringValue = this.stripeNonNumericChars(e.target.value);
        if (stringValue.length > this.maxInputLengthForHours) {
            return;
        }
        if (stringValue.length === 0) {
            const minutes = ((_a = this.getCurrentValues(this.props.input.value)) === null || _a === void 0 ? void 0 : _a.minutes) || 0;
            this.handleChange({ hours: 0, minutes });
            return;
        }
        const intValue = parseInt(stringValue);
        if (isPositiveFiniteNumber(intValue)) {
            const minutes = ((_b = this.getCurrentValues(this.props.input.value)) === null || _b === void 0 ? void 0 : _b.minutes) || 0;
            this.handleChange({ hours: intValue, minutes });
        }
    }
    handleMinutesInput(e) {
        var _a, _b;
        if (!e)
            return;
        const stringValue = this.stripeNonNumericChars(e.target.value);
        if (stringValue.length > this.maxInputLengthForMinutes) {
            return;
        }
        if (stringValue.length === 0) {
            const hours = ((_a = this.getCurrentValues(this.props.input.value)) === null || _a === void 0 ? void 0 : _a.hours) || 0;
            this.handleChange({ hours, minutes: 0 });
            return;
        }
        const intValue = parseInt(stringValue);
        if (isPositiveFiniteNumber(intValue) && intValue < 60) {
            const hours = ((_b = this.getCurrentValues(this.props.input.value)) === null || _b === void 0 ? void 0 : _b.hours) || 0;
            this.handleChange({ hours, minutes: intValue });
        }
    }
    stripeNonNumericChars(input) {
        return input.replace(/[^\d]+/g, '');
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        return (_jsxs("section", Object.assign({ className: cn(styles.root, this.props.className) }, { children: [_jsx(FieldText, Object.assign({}, this.props.hoursInputProps, { className: styles.hoursInput, input: {
                        name: 'hours',
                        onChange: this.handleHoursInput,
                        value: ((_b = (_a = this.getCurrentValues(this.props.input.value)) === null || _a === void 0 ? void 0 : _a.hours) === null || _b === void 0 ? void 0 : _b.toString()) || '',
                    }, meta: this.props.meta, type: "text", disabled: this.props.disabled })), _jsx(FieldText, Object.assign({}, this.props.minutesInputProps, { className: styles.minutesInput, input: {
                        name: 'minutes',
                        onChange: this.handleMinutesInput,
                        value: ((_d = (_c = this.getCurrentValues(this.props.input.value)) === null || _c === void 0 ? void 0 : _c.minutes) === null || _d === void 0 ? void 0 : _d.toString()) || '',
                    }, meta: {
                        // All error messages will be showed by hours input. but to keep them in sync
                        // An empty error message is sent to Minutes input to simulate having an error
                        // without showing an error message.
                        error: ((_e = this.props.meta) === null || _e === void 0 ? void 0 : _e.error) ? ' ' : null,
                        touched: (_f = this.props.meta) === null || _f === void 0 ? void 0 : _f.touched,
                    }, type: "text", disabled: this.props.disabled }))] })));
    }
}
__decorate([
    boundMethod
], DurationInput.prototype, "handleHoursInput", null);
__decorate([
    boundMethod
], DurationInput.prototype, "handleMinutesInput", null);
